import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Enums } from '../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-user-popover',
  templateUrl: './user-popover.component.html',
  styleUrls: ['./user-popover.component.scss'],
  standalone: false,
})
export class UserPopoverComponent implements OnInit {
  Enums = Enums;
  @Input() user;

  constructor() {}

  ngOnInit() {}

  toggleWithUserContext(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
}
